import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Avatar, AvatarImage, AvatarFallback } from "../ui/avatar";
import { Button } from "../ui/button";

import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const VcardPreview = ({ contact, numbers }) => {
	const navigate = useNavigate();
	const { user } = useContext(AuthContext);

	// O que o vCard diz. É o que a tela mostra ENQUANTO ninguém pediu nada:
	// desenhar uma mensagem não pode depender de ida ao servidor.
	const numeroDoCartao = (numbers || "").replace(/\D/g, "");
	const [selectedContact, setContact] = useState(null);

	const abrirConversa = async () => {
		try {
			// O contato só é criado AQUI, quando alguém pede para conversar.
			//
			// Antes isto rodava dentro de um `useEffect`, ao desenhar a
			// mensagem: abrir um atendimento que tivesse um cartão de contato
			// cadastrava aquela pessoa na agenda sozinho — e, quando o número
			// não existia no WhatsApp (cartão vindo do Telegram, telefone fixo,
			// número de outro país), a tela cuspia "Este não é um número de
			// Whatsapp válido" sem que ninguém tivesse clicado em nada.
			//
			// Ler uma conversa não pode escrever na agenda nem acusar erro.
			let contato = selectedContact;

			if (!contato) {
				const { data } = await api.post("/contacts", {
					name: contact,
					number: numeroDoCartao,
					email: "",
				});
				contato = data;
				setContact(data);
			}

			const { data: ticket } = await api.post("/tickets", {
				contactId: contato.id,
				userId: user.id,
				status: "open",
			});
			navigate(`/tickets/${ticket.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const iniciais = (selectedContact?.name || contact || "?")
		.split(" ")
		.slice(0, 2)
		.map((parte) => parte[0])
		.join("")
		.toUpperCase();

	return (
		<div className="w-[250px] overflow-hidden rounded-lg border bg-card">
			<div className="flex items-center gap-2.5 p-3">
				<Avatar className="h-10 w-10 shrink-0">
					<AvatarImage
						src={selectedContact?.profilePicUrl}
						alt={selectedContact?.name || contact}
					/>
					<AvatarFallback>{iniciais}</AvatarFallback>
				</Avatar>
				<div className="min-w-0">
					<p className="truncate text-sm font-medium">
						{selectedContact?.name || contact || "Contato"}
					</p>
					{(selectedContact?.number || numbers) && (
						<p className="truncate text-xs tabular-nums text-muted-foreground">
							{selectedContact?.number || numbers}
						</p>
					)}
				</div>
			</div>

			<div className="border-t">
				<Button
					variant="ghost"
					className="w-full rounded-none"
					onClick={abrirConversa}
					disabled={!numeroDoCartao}
				>
					Conversar
				</Button>
			</div>
		</div>
	);
};

export default VcardPreview;
